import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';

import { Space } from 'antd';

import Attribution from './attribution';
import Details from './details';
import CompareSection from './filter/compare';
import CompareButton from './filter/CompareButton';
import DashboardFilter from './filter/DashboardFilter';
import PeriodSelector from './period';
import { IAttributionItem, IDetailItem } from '../../../../../app/types/filter';
import { useTypedSelector } from '../../../hooks/useTypedSelector';

interface IParamsProps {
  withAttribution?: boolean;
  attributionItems?: IAttributionItem[];
  withDetails?: boolean;
  detailsItems?: IDetailItem[];
  withCompare?: boolean;
  withSegments?: boolean;
  filtersFilter?: string[];
  isFilterVisible?: boolean;
  setUpdateDashboard: () => void;
  fetchDashboardDataButtonVisible?: boolean;
  setFetchDashboardDataButtonVisible?: Dispatch<SetStateAction<boolean>>;
  isCollapsed?: boolean; // Свёрнутый режим - показывать только период
  compactStyle?: boolean; // Компактный стиль кнопок (теги)
}

const DashboardParams: FC<IParamsProps> = ({
  withAttribution = true,
  attributionItems,
  withDetails = true,
  detailsItems,
  withCompare = true,
  withSegments = true,
  filtersFilter,
  isFilterVisible = true,
  setUpdateDashboard,
  fetchDashboardDataButtonVisible = false,
  setFetchDashboardDataButtonVisible,
  isCollapsed = false,
  compactStyle = false,
}) => {
  const { isCompare } = useTypedSelector(
    (state) => state.meta
  );
  const [ stateAttributionItems, setStateAttributionItems ] = useState<IAttributionItem[]>([]);
  const [ stateDetailsItems, setStateDetailsItems ] = useState<IDetailItem[]>([]);
 

  useEffect(() => {
    if (attributionItems) {
      setStateAttributionItems(attributionItems);
    }
  }, [ attributionItems ]);

  useEffect(() => {
    if (detailsItems) {
      setStateDetailsItems(detailsItems);
    }
  }, [ detailsItems ]);

  // В свёрнутом режиме показываем только период
  if (isCollapsed) {
    return (
      <div
        className="dashboard-params-compact"
        style={{
          width: '100%',
          padding: '0',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {!isCompare && <PeriodSelector isCompare={isCompare} />}
      </div>
    );
  }

  return (
    <div
      className={compactStyle ? 'dashboard-params-compact' : ''}
      style={{
        width: '100%',
        padding: compactStyle ? '0' : '15px 15px 0px 25px',
        display: 'flex',
        flexDirection: compactStyle ? 'row' : 'column',
        flexWrap: compactStyle ? 'wrap' : 'nowrap',
        alignItems: compactStyle ? 'center' : 'flex-start',
        gap: compactStyle ? '8px' : '12px',
      }}
    >
      {!isCompare && <PeriodSelector isCompare={isCompare} />}
      {compactStyle ? (
        // Компактный стиль - всё в одну строку (display: contents убирает контейнеры)
        <>
          {withAttribution && stateAttributionItems && (
            <Attribution items={stateAttributionItems} isDashboard={true}/>
          )}
          {withCompare && <CompareButton isCompare={isCompare} />}
          {isCompare ? (
            <CompareSection filtersFilter={filtersFilter} />
          ) : (
            isFilterVisible && (
              <DashboardFilter
                preElement={withDetails && stateDetailsItems ? <Details items={stateDetailsItems} /> : undefined}
                isCompare={isCompare}
                withSegment={withSegments}
                filtersFilter={filtersFilter}
                setUpdateDashboard={setUpdateDashboard}
                fetchDashboardDataButtonVisible={fetchDashboardDataButtonVisible}
                setFetchDashboardDataButtonVisible={setFetchDashboardDataButtonVisible}
              />
            )
          )}
        </>
      ) : (
        // Стандартный стиль
        <>
          <Space
            direction="horizontal"
            style={{
              position: 'relative',
              display: 'flex',
              flexWrap: 'wrap', 
            }}
          >
            {withAttribution && stateAttributionItems && (
              <div>
                <Attribution items={stateAttributionItems} isDashboard={true}/>
              </div>
            )}
            {withDetails && stateDetailsItems && <Details items={stateDetailsItems} />}
            {withCompare && <CompareButton isCompare={isCompare} />}
          </Space>
          <div className="filter-wrapper">
            {isCompare ? (
              <CompareSection filtersFilter={filtersFilter} />
            ) : (
              isFilterVisible && (
                <DashboardFilter
                  isCompare={isCompare}
                  withSegment={withSegments}
                  filtersFilter={filtersFilter}
                  setUpdateDashboard={setUpdateDashboard}
                  fetchDashboardDataButtonVisible={fetchDashboardDataButtonVisible}
                  setFetchDashboardDataButtonVisible={setFetchDashboardDataButtonVisible}
                />
              )
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default DashboardParams;